import { generatePath, Navigate } from "react-router";

import { getFirstDayOfMonth } from "@/lib/dayjs/get-first-day-of-month";
import { getLastDayOfMonth } from "@/lib/dayjs/get-last-day-of-month";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";
import type { RoomPriceRank_RoomPriceRankPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { RoomPriceRankSettingPresenter } from "./presenter";
import { useFetchRoomPriceRankDailyStatus } from "../../model/price-rank-and-daily-status/_shared/daily-stasus/repository/query/fetch-room-price-rank-daily-status/use-fetch-room-price-rank-daily-status";
import { useFetchRoomPriceRank } from "../../model/price-rank-and-daily-status/_shared/price-rank/repository/query/fetch-room-price-rank/use-fetch-room-price-rank";

type Props = {
	hotelID: string;
};

export const RoomPriceRankSettingContainer = ({ hotelID }: Props) => {
	const { data: roomPriceRank } = useFetchRoomPriceRank({ hotelID });

	if (!roomPriceRank) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <RoomPriceRankSettingContainerInner hotelID={hotelID} roomPriceRank={roomPriceRank} />;
};

const RoomPriceRankSettingContainerInner = ({
	hotelID,
	roomPriceRank,
}: Props & { roomPriceRank: RoomPriceRank_RoomPriceRankPageQuery }) => {
	const todaysDate = getTodaysDate();
	const startDt = getFirstDayOfMonth({ date: todaysDate });
	const endDt = getLastDayOfMonth({ date: todaysDate });

	const { data: roomPriceRankDailyStatus, onRefetch } = useFetchRoomPriceRankDailyStatus({
		hotelID,
		startDt,
		endDt,
	});

	if (!roomPriceRankDailyStatus) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<RoomPriceRankSettingPresenter
			hotelID={hotelID}
			roomPriceRank={roomPriceRank}
			roomPriceRankDailyStatus={roomPriceRankDailyStatus}
			onRefetch={onRefetch}
		/>
	);
};

RoomPriceRankSettingContainer.displayName = "RoomPriceRankSettingContainer";
